"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.roles.super_admin': 'Super Admin',
    'user.roles.parent_user': 'Manager',
    'user.roles.enterprise': 'Impresa',
    'user.roles.user': 'Utente',
};
